import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white py-4 px-4 text-center mt-auto">
      <div className="text-sm text-gray-600">
        <span>Made with ☕ + ❤️ by Josiah</span>
      </div>
    </footer>
  );
};

export default Footer;